import React, { Component } from "react";
import "font-awesome/css/font-awesome.min.css";
import { Link } from "react-router-dom";
import {
  Button,
  Input,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  Tooltip,
  Container,
  Row,
  Col,
  Alert,
  Form,
  FormGroup,
  Card,
  CardBody,
} from "reactstrap";
import { withRouter } from "react-router-dom";
import * as Constdata from "../../Constants/ApiConstants";
import SerraError from "../CommonComponent/Error";
import Header from "../HeaderComponent/Header";
import ReactGA from "react-ga4";
import SerraLoader from "../CommonComponent/Loader";
import "./SignupPage.css";
import { FaCheck } from "react-icons/fa6";
import { FaEye } from "react-icons/fa6";
import { FaEyeSlash } from "react-icons/fa6";
import { FaArrowsRotate } from "react-icons/fa6";
import CryptoJS from "crypto-js";

import {
  loadCaptchaEnginge,
  LoadCanvasTemplateNoReload,
  validateCaptcha,
} from "react-simple-captcha";
import { connect } from "react-redux";
import * as message from "../../Constants/MessageConstant";
import { apiFetch } from "../../Constants/CommonConstant";

class SignupNew extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
    this.processResponse = this.processResponse.bind(this);
    this.toggle = this.toggle.bind(this);
    this.isDisabled = this.isDisabled.bind(this);
    this.setErrorPopupState = this.setErrorPopupState.bind(this);
    this.handleTerms = this.handleTerms.bind(this);
    this.onTermsAndConditionsClick = this.onTermsAndConditionsClick.bind(this);
    this.processResponseLogin = this.processResponseLogin.bind(this);
    this.onShowAlert = this.onShowAlert.bind(this);

    this.state = {
      num1: 1,
      num2: 5,
      result: "",
      hidden: true,
      tooltipOpen: false,
      submitDisabled: true,
      verifyColor: "",
      passwordcheck: "",
      confirmPass: "",
      fields: {},
      errors: {},
      formValid: false,
      errormessage: "",
      errorPopup: false,
      hasAgreed: false,
      isDisableconfirm: true,
      isfalse: false,
      modalLoader: false,
      passwordErrorCheck: {},
      isRedirect: false,
      alertMsg: false,
      visible: "",
      message: "",
      errorMsg: "",
    };
  }
  componentDidMount() {
    ReactGA.initialize(message.MeasurementId);
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "Sign Up",
    });
    loadCaptchaEnginge(6, "#AFAFAF");
  }

  handleTerms = () => {
    this.setState((prevState) => {
      return { hasAgreed: !prevState.hasAgreed };
    });
  };
  handleValidation() {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;
    //Name
    if (!fields["firstName"]) {
      formIsValid = false;
      errors["firstName"] = "First Name cannot be empty";
    }
    if (typeof fields["firstName"] !== "undefined") {
      if (!fields["firstName"].trim().match(/^[a-zA-Z\-\']+$/)) {
        formIsValid = false;
        errors["firstName"] = "Invalid character(s) present";
      }
    }
    if (!fields["lastName"]) {
      formIsValid = false;
      errors["lastName"] = " Last Name cannot be empty";
    }
    if (typeof fields["lastName"] !== "undefined") {
      if (!fields["lastName"].trim().match(/^[a-zA-Z\-\']+$/)) {
        formIsValid = false;
        errors["lastName"] = "Invalid character(s) present";
      }
    }
    //password
    if (!fields["password"]) {
      formIsValid = false;
      errors["password"] = "password cannot be empty";
    }
    if (typeof fields["password"] !== "undefined") {
      if (
        !fields["password"].match(
          /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,16}$/
        )
      ) {
        formIsValid = false;
        errors["password"] =
          "Your password in weak !! ,Please check password criteria hovering on the password field";
      }
    }
    //passwordConfirmpassword
    // if (!fields["passwordConfirm"]) {
    //   formIsValid = false;
    //   errors["passwordConfirm"] = "Confirm password cannot be empty";
    // }
    // if (typeof fields["passwordConfirm"] !== "undefined") {
    //   if (
    //     !fields["passwordConfirm"]
    //       .trim()
    //       .match(
    //         /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,16}$/
    //       )
    //   ) {
    //     formIsValid = false;
    //     errors["passwordConfirm"] =
    //       "Your password in weak !! ,Please check password criteria hovering on the password field";
    //   }
    // }
    //orgName
    if (!fields["orgName"].trim()) {
      formIsValid = false;
      errors["orgName"] = "Company Name cannot be empty";
    }
    //Email
    if (!fields["username"].trim()) {
      formIsValid = false;
      errors["username"] = "Work email cannot be empty";
    }
    if (typeof fields["username"] !== "undefined") {
      let lastAtPos = fields["username"].lastIndexOf("@");
      let lastDotPos = fields["username"].lastIndexOf(".");
      if (
        !(
          lastAtPos < lastDotPos &&
          lastAtPos > 0 &&
          fields["username"].indexOf("@@") === -1 &&
          lastDotPos > 2 &&
          fields["username"].length - lastDotPos > 2
        )
      ) {
        formIsValid = false;
        errors["username"] = "Email is not valid";
      }
    }
    //   if(!fields["verify"]){
    //     formIsValid = false;
    //     errors["verify"] = "Please verify capcha";
    //  }
    this.setState({ errors: errors, formValid: formIsValid });
    return formIsValid;
  }
  toggle = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  };
  toggleShow = () => {
    this.setState({ hidden: !this.state.hidden });
  };

  handleChange(field, e) {
    let fields = this.state.fields;
    fields[field] = e.target.value;
    this.setState({ fields });

    if (e.target.name === "password") {
      this.validator();
    }
  }
  handleSubmit(e) {
    e.preventDefault();
    const {
      firstName,
      lastName,
      password,
      // passwordConfirm,
      username,
      orgName,
    } = this.state.fields;
    let fName = firstName.trim();
    let lNAme = lastName.trim();
    let pwd = password.trim();
    // let cpwd = passwordConfirm.trim();
    let orgNm = orgName.trim();
    let uname = username.trim().toLowerCase();

    const encryptedPassword = CryptoJS.AES.encrypt(
      pwd,
      process.env.REACT_APP_SecretKey
    ).toString();

    const payload = {
      firstName: fName,
      lastName: lNAme,
      password: encryptedPassword,
      passwordConfirm: encryptedPassword,
      orgName: orgNm,
      username: uname,
      isFreeTrial: this.props.history.location.state?.isFreeTrial || false,
    };

    if (!this.handleValidation()) {
      return;
    }
    this.setState({ modalLoader: true });

    apiFetch(Constdata.SIGNUP_URL, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      body: JSON.stringify(payload),
    })
      .then((responseJson) => {
        this.processResponse(responseJson, payload.isFreeTrial);
        this.setState({
          firstName: "",
          lastName: "",
          orgName: "",
          password: "",
          // passwordConfirm: "",
          username: "",
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }
  processResponse(response, isFreeTrial) {
    if (response.success === true) {
      this.setState({ modalLoader: false });
      // if (isFreeTrial) {
      const { password, username } = this.state.fields;

      let pwd = password.trim();
      let uname = username.trim().toLowerCase();

      const encryptedPassword = CryptoJS.AES.encrypt(
        pwd,
        process.env.REACT_APP_SecretKey
      ).toString();

      const payload = {
        username: uname,
        password: encryptedPassword,
        forceLogout: false,
        providerName: "AZURE",
        aliasUsername: "",
      };

      apiFetch(Constdata.LOGIN_URL, {
        method: "POST",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        body: JSON.stringify(payload),
      })
        .then((responseJson) => {
          this.processResponseLogin(responseJson, response);
        })
        .catch((error) => {
          console.error(error);
        });

      // } else {
      //   this.props.history.push({
      //     pathname: "/success",
      //     state: { key: this.state.fields.username },
      //   });
      // }
    } else {
      this.setState({
        errorPopup: true,
        errormessage: response.message,
        modalLoader: false,
      });
      for (var i = 0; i < response.errorFields.length; i++) {
        if (response.errorFields[i].fieldName !== "") {
          this.setState({ error: response.errorFields[i].fieldName });
          this.state.errors[response.errorFields[i].fieldName] =
            response.errorFields[i].error;
        }
      }
    }
  }

  processResponseLogin = async (response, responseRegistration) => {
    if (response.success === true) {
      window.localStorage.setItem(
        "loggedInUser",
        response.data.loggedInUser.toLowerCase()
      );
      this.setState({
        visible: response.success,
        data: response.data,
      });
      if (
        (response.orgInfo.plan === "Free Trial" ||
          response.orgInfo.plan === "FREE_TRIAL") &&
        response.orgInfo.loggedInUser !== "support@serralabs.com" &&
        response.orgInfo.userName !== "support@serralabs.com"
      ) {
        this.props.history.push({
          pathname: `/free-trial`,
          state: {
            providerName: response.orgInfo.providerName,
            step: 1,
          },
        });
      } else {
        this.setState({
          modalLoader: false,
        });
        if (response.data.landingPage === "report") {
          this.props.history.push({
            pathname: `/${
              response.orgInfo.loggedInUser === "support@serralabs.com"
                ? "dashboard"
                : response.data.landingPage
            }`,
            state: { data: this.state.data.data },
          });
        } else {
          this.props.history.push({
            pathname: `/${
              response.orgInfo.loggedInUser === "support@serralabs.com"
                ? "dashboard"
                : response.data.landingPage
            }`,
            state: { data: this.state.data },
          });
        }
      }
    } else {
      if (
        responseRegistration.success &&
        response.message === "User account not verified"
      ) {
        this.setState({
          errorPopup: true,
          errormessage: responseRegistration.message,
          modalLoader: false,
          isRedirect: true,
        });
      } else {
        await this.setState({
          errorMsg: response.message,
          visible: response.success,
          disableSignIn: false,
          modalLoader: false,
        });
        await this.onShowAlert();
      }
    }
  };

  validator = () => {
    const { password } = this.state.fields;

    const requirements = {
      digit: /\d/,
      lowercase: /[a-z]/,
      uppercase: /[A-Z]/,
      specialChar: /[^a-zA-Z0-9]/,
      length: /^.{8,16}$/,
    };

    const errors = {
      hasLength: true,
      hasLowerCase: true,
      hasUpperCase: true,
      hasNumber: true,
      hasSpecialChar: true,
    };

    if (!requirements.digit.test(password)) {
      errors.hasNumber = false;
    }
    if (!requirements.lowercase.test(password)) {
      errors.hasLowerCase = false;
    }
    if (!requirements.uppercase.test(password)) {
      errors.hasUpperCase = false;
    }
    if (!requirements.specialChar.test(password)) {
      errors.hasSpecialChar = false;
    }
    if (!requirements.length.test(password)) {
      errors.hasLength = false;
    }

    this.setState({ passwordErrorCheck: errors });

    var reg =
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,16}$/;
    var test = reg.test(password);

    if (test) {
      this.setState(() => {
        return { passwordcheck: "valid", isDisableconfirm: false };
      });
    } else {
      this.setState(() => {
        return { passwordcheck: "invalid", isDisableconfirm: true };
      });
    }
  };
  confirmpassword = () => {
    const { password, passwordConfirm } = this.state.fields;
    if (password === passwordConfirm) {
      this.setState({ confirmPass: "valid" });
    } else {
      this.setState({ confirmPass: "invalid" });
    }
  };
  checkvalidity = (e) => {
    this.setState({ result: e.target.value });
  };

  isDisabled = () => {
    const { result, passwordcheck, verifyColor } = this.state;
    const {
      firstName,
      lastName,
      // passwordConfirm,
      password,
      username,
      orgName,
    } = this.state.fields;
    const isAllFilled =
      firstName &&
      lastName &&
      // passwordConfirm &&
      password &&
      username &&
      orgName &&
      result;
    // &&
    // hasAgreed
    const isValidPass = passwordcheck === "valid" && verifyColor === "valid";
    return !(isAllFilled && isValidPass);
  };
  setErrorPopupState = (event) => {
    this.setState({ errorPopup: event });
    if (this.state.isRedirect) {
      this.props.history.push({
        pathname: "/",
      });
    }
  };

  doSubmit = () => {
    let user_captcha = document.getElementById("user_captcha_input").value;
    this.setState({ result: user_captcha });
    if (validateCaptcha(user_captcha, false) === true) {
      this.setState({ verifyColor: "valid" });
    } else {
      this.setState({ verifyColor: "invalid" });
    }
  };

  resetCaptcha = () => {
    loadCaptchaEnginge(6, "#AFAFAF");
    document.getElementById("user_captcha_input").value = "";
    this.setState({ verifyColor: "invalid" });
  };

  onTermsAndConditionsClick() {
    window.open(this.props.companyDetails.TermsAndConditions);
  }

  onShowAlert = () => {
    this.setState({ alertMsg: true }, () => {
      window.setTimeout(() => {
        this.setState({ alertMsg: false });
      }, 5000);
    });
  };

  render() {
    let passwordvalid = (
      <Input
        type={this.state.hidden ? "password" : "text"}
        onKeyUp={this.validator.bind(this)}
        // className="form-control"
        id="password"
        name="password"
        value={this.state.fields["password"]}
        onChange={this.handleChange.bind(this, "password")}
        autoComplete="new-password"
        placeholder="Password"
      />
    );
    if (this.state.passwordcheck === "valid") {
      passwordvalid = (
        <Input
          type={this.state.hidden ? "password" : "text"}
          onKeyUp={this.validator.bind(this)}
          // className="form-control"
          id="password"
          name="password"
          value={this.state.fields["password"]}
          onChange={this.handleChange.bind(this, "password")}
          autoComplete="new-password"
          valid
          placeholder="Password"
        />
      );
    } else if (this.state.passwordcheck === "invalid") {
      passwordvalid = (
        <Input
          type={this.state.hidden ? "password" : "text"}
          onKeyUp={this.validator.bind(this)}
          // className="form-control"
          id="password"
          name="password"
          value={this.state.fields["password"]}
          onChange={this.handleChange.bind(this, "password")}
          autoComplete="new-password"
          invalid
          placeholder="Password"
        />
      );
    }

    let verifycapcha = (
      <Input
        type="text"
        className="form-control"
        placeholder="Enter Captcha Value"
        id="user_captcha_input"
        name="user_captcha_input"
        onKeyUp={() => this.doSubmit()}
        // disabled={!this.state.hasAgreed}
      />
    );
    if (this.state.verifyColor === "valid") {
      verifycapcha = (
        <Input
          type="text"
          className="form-control"
          placeholder="Enter Captcha Value"
          id="user_captcha_input"
          name="user_captcha_input"
          onKeyUp={() => this.doSubmit()}
          valid
        />
      );
    } else if (this.state.verifyColor === "invalid") {
      verifycapcha = (
        <Input
          type="text"
          className="form-control"
          placeholder="Enter Captcha Value"
          id="user_captcha_input"
          name="user_captcha_input"
          onKeyUp={() => this.doSubmit()}
          invalid
        />
      );
    }

    return (
      <div className="signupNewDesign">
        <header className="container-fluid py-2">
          <Row className="align-items-center">
            <Col xs="auto">
              <img
                src={this.props.companyDetails.LOGO}
                alt="Serra Labs Logo"
                height={48}
              />
            </Col>
            <Col className="text-center">
              <h1 className="header-title mb-0">Serra Labs Platform Console</h1>
            </Col>
            <Col xs="auto" style={{ width: "87px" }}></Col>
          </Row>
        </header>

        <hr className="gradient-divider" />

        <main className="container-fluid py-4 py-lg-5">
          <Container className="">
            <Row className="g-4 g-lg-5">
              <Col lg="7">
                <div className="mb-4 mb-lg-5">
                  {/* <h2 className="main-title mb-3">
                    Reduce Cost, Improve Performance
                  </h2> */}
                  <h3 className="section-title mb-3">
                    Optimize Your Workloads (VMs) for Maximum Savings, Maximum
                    Value or Maximum Speed using the Serra Labs Platform.
                  </h3>
                </div>
                <div className="mb-4 mb-lg-5">
                  <h3 className="section-title mb-3">
                    Your free trial includes:
                  </h3>
                  <div
                    className="d-flex flex-column gap-3"
                    style={{ gap: "16px" }}
                  >
                    {[
                      "Optimization Dashboard",
                      "Detailed VM Rightsizing Recommendations",
                      "Detailed VM Parking Recommendations",
                      "Clean Up Detached Resources",
                      "White glove setup and consultation (optional)",
                      "No time limit",
                    ].map((text, idx) => (
                      <div
                        className="d-flex align-items-start"
                        style={{ gap: 15 }}
                        key={idx}
                      >
                        <FaCheck color="#00a17a" size="20" />
                        <span className="feature-text">{text}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <Col className="d-flex flex-column justify-content-center">
                  <h5>Demo Video</h5>
                  {/* <iframe
                    src={`${require("../../docs/AWS_Configuration_Serra_Labs.pdf")}#navpanes=0`}
                    width="95%"
                    height="500px"
                    title="PDF Viewer"
                  /> */}
                  <video
                    width="700"
                    height="400"
                    controls
                    autoPlay={false}
                    muted
                  >
                    <source
                      src={require("../../docs/Video/Serra_Console_Login_Animation_Demo_v18.mp4")}
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                </Col>
                {/* <div className="text-center">
                  <img
                    src={require("../../images/screenshot.png")}
                    alt="Cost Savings Chart"
                    className="img-fluid"
                  />
                </div> */}
              </Col>

              <Col lg="5">
                <div className="d-flex flex-column align-items-center">
                  <div
                    className="signup-card w-100"
                    style={{ maxWidth: "448px" }}
                  >
                    {/* <CardBody> */}
                    <div className="text-center mb-4">
                      <h3 className="form-title mb-2">
                        No credit card required
                      </h3>
                      <p className="description-text">
                        Requires read-only access to an AWS or Azure environment
                        using cloud provider recommended authentication methods.
                      </p>
                    </div>
                    <form onSubmit={this.handleSubmit}>
                      {/* <Form onSubmit={handleSubmit}> */}
                      <FormGroup>
                        <Row className="g-2 inputBox">
                          <Col md="6" style={{ paddingLeft: "0" }}>
                            <Input
                              type="text"
                              placeholder="First Name"
                              name="firstName"
                              onChange={this.handleChange.bind(
                                this,
                                "firstName"
                              )}
                              value={this.state.fields["firstName"]}
                            />
                            <span style={{ color: "red", fontSize: "12px" }}>
                              {this.state.errors["firstName"]}
                            </span>
                          </Col>
                          <Col md="6" style={{ paddingRight: "0" }}>
                            <Input
                              type="text"
                              placeholder="Last Name"
                              name="lastName"
                              onChange={this.handleChange.bind(
                                this,
                                "lastName"
                              )}
                              value={this.state.fields["lastName"]}
                            />
                            <span style={{ color: "red", fontSize: "12px" }}>
                              {this.state.errors["lastName"]}
                            </span>
                          </Col>
                        </Row>
                      </FormGroup>
                      <FormGroup>
                        <Input
                          type="email"
                          placeholder="Business Email"
                          name="email"
                          value={this.state.fields["username"]}
                          onChange={this.handleChange.bind(this, "username")}
                          autoComplete="email"
                        />
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {this.state.errors["username"]}
                        </span>
                      </FormGroup>
                      <FormGroup>
                        <Input
                          type="text"
                          placeholder="Company Name"
                          name="company"
                          value={this.state.fields["orgName"]}
                          onChange={this.handleChange.bind(this, "orgName")}
                          autoComplete="off"
                        />
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {this.state.errors["orgName"]}
                        </span>
                      </FormGroup>
                      <FormGroup className="position-relative">
                        {passwordvalid}
                        <Tooltip
                          placement="right"
                          trigger="focus"
                          isOpen={this.state.tooltipOpen}
                          hideArrow={true}
                          target="password"
                          toggle={this.toggle}
                          className="tooltipSignup"
                          style={{ textAlign: "left", minWidth: "fit-content" }}
                        >
                          <div>
                            <h6>Password restrictions:</h6>
                            <div
                              style={{
                                display: "flex",
                                gap: "10px",
                                alignItems: "center",
                              }}
                            >
                              <div>
                                {this.state.passwordErrorCheck?.hasLength ===
                                undefined ? (
                                  <p style={{ marginBottom: "0px" }}>&bull;</p>
                                ) : this.state.passwordErrorCheck?.hasLength ? (
                                  <img
                                    style={{ minWidth: "15px" }}
                                    src={require("../../images/GoodTickIcon_01.svg")}
                                    width={15}
                                  />
                                ) : (
                                  <img
                                    style={{ minWidth: "15px" }}
                                    src={require("../../images/PoorCrossIcon_01.svg")}
                                    width={15}
                                  />
                                )}
                              </div>
                              <div>Between 8 and 16 characters.</div>
                            </div>
                            <div style={{ paddingTop: "8px" }}>
                              At least one of each of the following :
                            </div>
                            <div>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "10px",
                                  alignItems: "center",
                                }}
                              >
                                <div>
                                  {this.state.passwordErrorCheck
                                    ?.hasLowerCase === undefined ? (
                                    <p style={{ marginBottom: "0px" }}>
                                      &bull;
                                    </p>
                                  ) : this.state.passwordErrorCheck
                                      ?.hasLowerCase ? (
                                    <img
                                      style={{
                                        minWidth: "15px",
                                        padding: " 8px 0",
                                      }}
                                      src={require("../../images/GoodTickIcon_01.svg")}
                                      width={15}
                                    />
                                  ) : (
                                    <img
                                      style={{
                                        minWidth: "15px",
                                        padding: " 8px 0",
                                      }}
                                      src={require("../../images/PoorCrossIcon_01.svg")}
                                      width={15}
                                    />
                                  )}
                                </div>
                                lowercase letter
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "10px",
                                  alignItems: "center",
                                }}
                              >
                                <div>
                                  {this.state.passwordErrorCheck
                                    ?.hasUpperCase === undefined ? (
                                    <p style={{ marginBottom: "0px" }}>
                                      &bull;
                                    </p>
                                  ) : this.state.passwordErrorCheck
                                      ?.hasUpperCase ? (
                                    <img
                                      style={{
                                        minWidth: "15px",
                                        padding: " 8px 0",
                                      }}
                                      src={require("../../images/GoodTickIcon_01.svg")}
                                      width={15}
                                    />
                                  ) : (
                                    <img
                                      style={{
                                        minWidth: "15px",
                                        padding: " 8px 0",
                                      }}
                                      src={require("../../images/PoorCrossIcon_01.svg")}
                                      width={15}
                                    />
                                  )}
                                </div>
                                uppercase letter
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "10px",
                                  alignItems: "center",
                                }}
                              >
                                <div>
                                  {this.state.passwordErrorCheck?.hasNumber ===
                                  undefined ? (
                                    <p style={{ marginBottom: "0px" }}>
                                      &bull;
                                    </p>
                                  ) : this.state.passwordErrorCheck
                                      ?.hasNumber ? (
                                    <img
                                      style={{
                                        minWidth: "15px",
                                        padding: " 8px 0",
                                      }}
                                      src={require("../../images/GoodTickIcon_01.svg")}
                                      width={15}
                                    />
                                  ) : (
                                    <img
                                      style={{
                                        minWidth: "15px",
                                        padding: " 8px 0",
                                      }}
                                      src={require("../../images/PoorCrossIcon_01.svg")}
                                      width={15}
                                    />
                                  )}
                                </div>
                                numeric character
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "10px",
                                  alignItems: "center",
                                }}
                              >
                                <div>
                                  {this.state.passwordErrorCheck
                                    ?.hasSpecialChar === undefined ? (
                                    <p style={{ marginBottom: "0px" }}>
                                      &bull;
                                    </p>
                                  ) : this.state.passwordErrorCheck
                                      ?.hasSpecialChar ? (
                                    <img
                                      style={{
                                        minWidth: "15px",
                                        padding: " 8px 0",
                                      }}
                                      src={require("../../images/GoodTickIcon_01.svg")}
                                      width={15}
                                    />
                                  ) : (
                                    <img
                                      style={{
                                        minWidth: "15px",
                                        padding: " 8px 0",
                                      }}
                                      src={require("../../images/PoorCrossIcon_01.svg")}
                                      width={15}
                                    />
                                  )}
                                </div>
                                special character
                              </div>
                            </div>
                          </div>
                        </Tooltip>
                        <Button
                          type="button"
                          className="eyeButton btn-link position-absolute"
                          style={{
                            border: "none",
                            background: "none",
                            color: "#6a6a6a",
                          }}
                          onClick={this.toggleShow.bind(this)}
                        >
                          {this.state.hidden ? <FaEyeSlash /> : <FaEye />}
                        </Button>

                        <div>
                          <span style={{ color: "red", fontSize: "12px" }}>
                            {this.state.errors["password"]}
                          </span>{" "}
                        </div>
                      </FormGroup>
                      <FormGroup>
                        <div className="captcha-placeholder mb-2 position-relative">
                          <div className="verf-qestion">
                            <LoadCanvasTemplateNoReload />
                          </div>

                          <Button
                            type="button"
                            className="refreshButton btn-link position-absolute"
                            style={{
                              border: "none",
                              background: "none",
                              color: "#6a6a6a",
                            }}
                            onClick={() => this.resetCaptcha(this)}
                          >
                            <FaArrowsRotate color="black" />
                          </Button>
                        </div>
                        {verifycapcha}
                        <div>
                          <span style={{ color: "red", fontSize: "12px" }}>
                            {this.state.errors["verify"]}
                          </span>
                        </div>
                      </FormGroup>

                      <p className="terms-text mb-3">
                        {/* <Input
                          className="form-check-input-nontable"
                          type="checkbox"
                          id="hasAgreed"
                          name="hasAgreed"
                          value={this.state.hasAgreed}
                          onChange={this.handleTerms}
                        />{" "} */}
                        All fields required. By signing up, you agree to the
                        <span>
                          <Link
                            onClick={this.onTermsAndConditionsClick}
                            style={{ fontSize: "13px" }}
                          >
                            {" "}
                            Terms and Conditions
                          </Link>
                        </span>
                      </p>
                      <Button
                        type="submit"
                        className="btn-signup w-100 mb-3"
                        id={
                          this.isDisabled()
                            ? "btnSinginSignup_disabledNew"
                            : "btnSinginSignupNew"
                        }
                        disabled={this.isDisabled()}
                      >
                        Sign Up
                      </Button>
                    </form>
                    {/* </Form> */}
                    <div className="text-center">
                      <p className="signin-text mb-0">
                        Already have an account?{" "}
                        <span className="signin-link">
                          <Link to={"/"} style={{ fontSize: "16px" }}>
                            Sign In
                          </Link>
                        </span>
                      </p>
                    </div>
                    {/* </CardBody> */}
                  </div>
                  {/* <div
                    className="customer-quote w-100 mt-4"
                    style={{ maxWidth: "448px" }}
                  >
                    <p className="quote-text mb-2">
                      "Customer quote goes here"
                    </p>
                    <p className="quote-author mb-0">- A Customer</p>
                  </div> */}
                </div>
              </Col>
            </Row>
          </Container>
        </main>

        {this.state.errorPopup === true ? (
          <SerraError
            Errordata={this.state.errormessage}
            ErrorPopup={this.state.errorPopup}
            setErrorMethod={this.setErrorPopupState}
          ></SerraError>
        ) : (
          ""
        )}
        {this.state.modalLoader === true ? <SerraLoader></SerraLoader> : ""}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    companyDetails: state.companyDetails.data,
  };
};

export default connect(mapStateToProps, null)(withRouter(SignupNew));
